export default {
  distributor: {
    general: {
      unit_minute: '分',
      unit_order: '單',
      filter: '篩選',
      op_successful: '操作成功',
      less_than: '不超過',
      unit_money: '元',
      unit_weight: '公斤',
    },
    title: {
      phone_verification: '手機驗證',
      create_account: '建立帳號',
      account_info: '個人資訊',
      status_online: '工作中',
      status_offline: '休息中',
      configuration: '系統設定',
      settle_list: '結算管理',
      history: '歷史訂單',
      order_list: '訂單列表',
      register_info: '上傳資料',
      message: '我的通知',
    },
    menu: {
      home: '首頁',
      map: '地圖',
      point_record: '點數紀錄',
      errand: '跑腿',
      my: '我的',
    },
    login: {
      register: '成為外送員',
      sms_captcha: '簡訊驗證碼',
      input_name: '請輸入姓名',
      input_password: '請輸入密碼',
      input_password_confirm: '確認密碼',
    },
    account: {
      deliver_area: '配送區域',
      real_name: '真實姓名',
      account_safe: '帳號安全',
      login_password: '登入密碼',
      modify_login_password: '修改密碼',
      modify_tel_number: '修改手機號碼 {0}',
      modify_email: '修改信箱 {0}',
      sms_captcha: '簡訊驗證碼',
      new_tel_number: '新手機號碼',
      new_email: '新信箱',
      new_password: '新密碼',
      confirm_password: '確認密碼',
      introduction: '自我介紹',
      today_average_time: '今日平均用時',
      totay_total_orders: '今日總完成',
      deliver_orders: '外送訂單',
      history: '歷史訂單',
      profile: '個人資訊',
      settle_list: '結算管理',
      messages: '我的通知',
      account: '帳號設定',
      configuration: '系統設定',
      occupy_setting: '接單設定',
      manual_occupy: '手動接單',
      auto_occupy: '自動接單',
      occupy_limit: '同時接單上限(0不限)',
      occupy_limit_notice: '目前最多同時接{0}筆單',
      captcha_type: '驗證方式',
      email: '信箱',
      mobile: '手機',
      captcha: '驗證碼',
      upload_id_front: '請上傳身份證正面',
      upload_id_back: '請上傳身份證反面',
      upload_bank: '請上傳收款帳戶存摺',
    },
    action: {
      online: '開始接單',
      offline: '停止接單',
      refresh: '更新',
      send: '發送',
      report_payment_amount: '付款金額回報',
      payment_amount_reported: '已回報金額'
    },
    dashboard: {
      empty: '<p>暫時沒有訂單喔</p><p>請耐心等候</p>',
      account_verifying: '<p>尚未通過審核</p><p>請耐心等候</p>',
      item: '品項',
      item_unit: '件',
      distance: '距離',
      distance_unit: '公里',
      elapsed_time: '花費時間',
      elapsed_time_unit: '分',
      pickup: '取',
      deliver: '送',
      total: '共計',
      order_detail: '訂單詳情',
      order_map: '訂單地圖',
      order_list: '購物清單',
      total_amount: '總金額',
      buyer_message: '買家備註',
      operation_time: '操作時間',
      order_release_time: '派單時間',
      order_occupy_time: '接單時間',
      order_arrived_time: '到達店家時間',
      order_pickup_time: '取貨時間',
      order_successful_time: '送達時間',
      op_occupy: '接受訂單',
      op_arrived: '已抵達店家',
      op_ready: '我要取餐',
      op_pickup: '已領取餐點',
      op_pickup_confirm: '確定已領取餐點嗎',
      op_receive: '用戶已收',
      carrier_code: '電子載具號碼',
      carrier_note: '請讓店家掃描顧客電子載具',
      tax_id_number: '統一編號',
      tax_id_note: '請店家開立統一編號發票',
      op_receive_code: '請輸入6位數收貨碼',
    },
    settle: {
      o2o_buy: '配送訂單',
      o2o_send: '跑腿訂單',
      complaint: '投訴',
      income: '收入',
      outlay: '支出',
      distributor_bank: '收款帳號',
      confirm: '結算',
      balance: '目前餘額',
      all_confirm: '一鍵結算',
      settle_types: {
        title: '請選擇結算方式',
        account: '收款帳號',
        cash: '現金結算',
      },
      settle_account_title: '確定使用收款結算？',
      settle_account_note1: '審核完成後將會在5分鐘內將金額匯入至',
      settle_account_note2: '收款帳號: {0}',
      settle_cash_title: '確定使用現金結算？',
      settle_cash_note1: '提交申請待審核完畢後請至總部與會計結算',
      settle_cash_note2: '地址: {0}',
      settle_cash_confirm_button: '提交現金結算申請',
      settle_confirmed: '審核完畢',
      payment_note_title: '現金結算審核完畢',
      payment_note_line1: '請至總部並將此畫面交給會計',
      payment_note_line2: '地址: {0}',
      payment_note_line3: '結算金額: {0}',
      payment_confirm_passowrd: '請會計輸入結算密碼',
    },
    order: {
      destination: '目的地',
      time: '時間',
      start_time: '開始時間',
      end_time: '結束時間',
      order_detail: '訂單詳情',
      real_amount: '實際付款金額',
      real_amount_placeholder: '請輸入實際付款金額',
      upload_menu: '上傳菜單照片',
      report_successfully: '回報成功！',
    },
    errand: {
      sections: {
        pending: '待搶單',
        deliver: '進行中訂單',
      },
      status: '狀態',
      pickup_time: '取貨時間',
      on_behalf_amount: '代付款',
      invoice_status_checked: '索取發票',
      invoice_status_none: '無發票',
      distance: '距離',
      order_sn: '訂單編號',
      order_info: '訂單資訊',
      order_distance: '路程',
      actions: {
        pick: '接單',
        pickup: '取貨',
        done: '完成',
        map: '地圖',
        detail: '詳細',
      },
      op_receive_code: '請輸入6位數收貨碼',
      deliver_now: '立即出發',
      pickup_address: '取貨地址',
      deliver_address: '送貨地址',
      order_detail: '物品資訊',
      order_weight: '物品重量',
      order_goods_price: '物品價值',
      order_time: '訂單時間',
      appointment_time: '預約時間',
      payment_time: '付款時間',
      successful_time: '完成時間',
      remark: '備註',
      extra_price: {
        shipping: '基礎運費',
        weight: '重量附加費',
        time: '特殊時段費',
        tip: '小費',
      },
      total_amount: '實付金額',
      errand_send_state: {
        0: '已取消',
        10: '待付款',
        20: '待接單',
        26: '待取貨',
        30: '派送中',
        40: '已完成'
      },
    },
    errand_order_list: {
      nav: {
        all: '全部',
        occupied: '待取貨',
        delivering: '配送中',
        done: '已完成',
      },
      order_sn: '訂單編號',
      total: '合計',
    },
  }
}
